<template>
  <div class="block">
    <el-carousel :height="bannerHeight+'px'">
      <el-carousel-item v-for="(item,i) in swiper" :key="i"  >
        <img  ref="bannerHeight" :src="item" alt="" @load="imgLoad" style="width: 100%">
      </el-carousel-item>
    </el-carousel>

  </div>
</template>

<script>
import url from "../api/baseurl";
export default {
  // props:["height"],
  data() {
    return {
      swiper:[],
      bannerHeight:"",
    };
  },

  methods: {
    imgLoad(){
                this.$nextTick(()=>{
                    this.bannerHeight=this.$refs.bannerHeight[0].height
                })
            },
    // 获取合作伙伴列表
    swiperList(){
      this.$api.getIndexMenu().then(res=>{
        let banner=res.data.menu_list[0].banner
        for(let i=0;i<banner.length;i++){
          banner[i]=url + banner[i]
          this.swiper.push(banner[i])
        }
      })
    },
    
  },
  mounted() {
    this.imgLoad();
    window.addEventListener('resize',() => {
    this.imgLoad();
    },false),
    //获取合作伙伴列表 
    this.swiperList()
  },

};
</script>

<style lang="less" scoped>

@media screen and (min-width: 1200px) {
  // /deep/.el-carousel__indicators--horizontal{
  //   bottom: 120px !important;
  // }
  .block{
    width: 100%;
  }
  img{
    // width: auto;
    // height: auto;
    width: 100%;
    height: auto;
  }
  /deep/.el-carousel__button{
    width: 0.5rem;
    height: 0.04rem;
  }
  /deep/.el-carousel__indicator--horizontal{
    padding: 0.08rem 0.15rem;
    
  }
  // /deep/.el-carousel__container{
  //   height: 6rem;
  // }

  /deep/.el-carousel__arrow{
    width: 0.5rem;
    height: 0.5rem;
    font-size: 0.3rem;
  }
}

@media screen and (max-width: 750px) {
  .block{
    width: 100%;
  }
  // img{
  //   width: 100%;
  //   height: 100%;
  // }
  /deep/.el-carousel__button{
    width: 0.15rem;
    height: 0.02rem;
  }
  /deep/.el-carousel__indicator--horizontal{
    padding: 0.08rem 0.05rem;
  }
  /deep/.el-carousel__container{
    height: 2rem;
  }

  /deep/.el-carousel__arrow{
    width: 0.5rem;
    height: 0.5rem;
    font-size: 0.3rem;
  }  
}




</style>